<script setup>
import { useI18n } from 'vue-i18n';
import { useAppLocale } from 'dashboard/composables/useAppLocale';

const props = defineProps({
  events: { type: Array, required: true },
  catalog: { type: Array, required: true },
});
defineEmits(['retry']);
const { t } = useI18n();
const { formatDateTime } = useAppLocale();
const label = event => {
  if (event.event_name === 'NotConverted')
    return t('META_CAPI.BOX.NOT_CONVERTED');
  const option = props.catalog.find(item => item.name === event.event_name);
  return option ? t(`META_CAPI.EVENTS.${option.key}`) : event.event_name;
};
</script>

<template>
  <div
    v-for="event in events.slice(0, 5)"
    :key="event.id"
    class="flex flex-col gap-1 py-2 border-b border-n-weak last:border-b-0"
  >
    <span class="text-sm text-n-slate-12">{{ label(event) }}</span>
    <span v-if="event.test_event" class="text-xs text-n-blue-11">{{
      t('META_CAPI.DELIVERY.TEST')
    }}</span>
    <span class="text-xs text-n-slate-11">
      {{ t(`META_CAPI.DELIVERY.${event.status.toUpperCase()}`) }}
      <template v-if="event.value !== null">
        · {{ event.currency }} {{ event.value }}
      </template>
    </span>
    <span class="text-xs text-n-slate-10">
      {{ formatDateTime(event.occurred_at || event.created_at) }}
      <template v-if="event.origin">
        · {{ t(`META_CAPI.ORIGIN.${event.origin.toUpperCase()}`) }}
      </template>
      · {{ t('META_CAPI.DELIVERY.ATTEMPTS', { count: event.attempts || 0 }) }}
    </span>
    <span v-if="event.error" class="text-xs text-n-ruby-11 break-words">
      {{ event.error }}
    </span>
    <button
      v-if="event.retryable"
      class="text-xs text-n-blue-11 self-start"
      @click="$emit('retry', event.id)"
    >
      {{ t('META_CAPI.DELIVERY.RETRY_ACTION') }}
    </button>
  </div>
</template>
